export const editorConfiguration = {
    toolbar: [
        "bold",
        "italic",
        "underLine",
        "|",
        "alignment:left",
        "alignment:right",
        "alignment:center",
        "alignment:justify",
        "|",
        "bulletedList",
        "numberedList",
        "|",
        "highlight",
        "|",
        "undo",
        "redo"
    ],
    removePlugins: ["Title", "ListStyle"],
    alignment: {
        options: ["left", "right", "center", "justify"]
    },
    highlight: {
        options: [
            {
                model: "yellowMarker",
                class: "marker-yellow",
                title: "Yellow marker",
                color: "var(--ck-highlight-marker-yellow)",
                type: "marker"
            },
            {
                model: "greenMarker",
                class: "marker-green",
                title: "Green marker",
                color: "#32CD32",
                type: "marker"
            },
            {
                model: "pinkMarker",
                class: "marker-pink",
                title: "Pink marker",
                color: "#FF00FF",
                type: "marker"
            },
            {
                model: "blueMarker",
                class: "marker-blue",
                title: "Blue marker",
                color: "#0000FF",
                type: "marker"
            }
        ]
    },
    placeholder: "Type Here..."
};

/**
 * Adds the "No paragraph spacing" and "Formatting marks" (¶ / ↵) tools to an editor
 * config. Applied per editor so only the editors that opt in get them — currently the
 * Building > Executive Summary editors and the smart chart text editor.
 */
export const withParagraphTools = (config = {}) => {
    const items = [...(config.toolbar ?? [])];
    const undoIndex = items.indexOf("undo");
    const insertIndex = undoIndex > -1 ? undoIndex : items.length;
    items.splice(insertIndex, 0, "paragraphSpacing", "formattingMarks", "|");

    return { ...config, toolbar: items, formattingMarks: { enabled: true } };
};
